// extracted by mini-css-extract-plugin
export default {"shortcut":"XFO2","icon":"RDzo","shortcut-panel":"AJEb","shortcutPanel":"AJEb"};